import React from 'react';
import styled, { keyframes, useTheme } from 'styled-components';

// Create a rotation animation for the loading arc
const rotateArc = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Styled component for the SVG container
const SVGContainer = styled.div`
  width: ${(props) => props.size || '120px'};
  height: ${(props) => props.size || '120px'};

  .loading-arc {
    transform-origin: center;
    animation: ${rotateArc} 1.5s linear infinite;
  }
`;

/**
 * LoadingCircle component - displays a circular loading indicator with an animated arc
 *
 * @param {Object} props
 * @param {string} props.size - Size of the loading circle (e.g., '120px', '80px')
 * @param {string} props.className - Additional CSS classes
 */
const LoadingCircle = ({ size = '120px', className }) => {
  const theme = useTheme();

  return (
    <SVGContainer size={size} className={className}>
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 120 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        {/* Static circle outline */}
        <path
          d='M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM6 60C6 89.8234 30.1766 114 60 114C89.8234 114 114 89.8234 114 60C114 30.1766 89.8234 6 60 6C30.1766 6 6 30.1766 6 60Z'
          fill={theme.background.light}
        />

        {/* Animated blue arc - adding the className for animation */}
        <path
          className='loading-arc'
          d='M60 3C60 1.34315 61.3441 -0.00782388 62.9989 0.0749822C71.433 0.49703 79.6951 2.69558 87.2394 6.53961C95.676 10.8383 102.976 17.0726 108.541 24.7329C114.107 32.3932 117.78 41.2619 119.261 50.6139C120.586 58.9769 120.124 67.514 117.919 75.6658C117.486 77.2651 115.786 78.126 114.21 77.614C112.634 77.102 111.781 75.4111 112.204 73.8094C114.122 66.5604 114.512 58.9802 113.335 51.5525C112.002 43.1357 108.696 35.1538 103.687 28.2596C98.6779 21.3653 92.1084 15.7544 84.5155 11.8856C77.8149 8.47155 70.4853 6.49966 62.9985 6.08331C61.3442 5.99131 60 4.65685 60 3Z'
          fill={theme.primary.primary}
        />
      </svg>
    </SVGContainer>
  );
};

export default LoadingCircle;
